import type { SVGProps } from 'react';
const SvgDragHandle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#drag_handle_svg__a)">
      <path fill="currentColor" d="M20 9H4v2h16V9ZM4 15h16v-2H4v2Z" />
    </g>
    <defs>
      <clipPath id="drag_handle_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDragHandle;
